import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {FileSizeModule} from "ngx-filesize";
import {AppRoutingModule} from "../../app-routing.module";

import {
  MatButtonModule, MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule,
  MatInputModule, MatListModule, MatPaginatorModule, MatProgressSpinnerModule,
  MatSelectModule, MatSnackBarModule, MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule, MatTooltipModule
} from "@angular/material";

import {FileuploadModule} from "../../fileupload/fileupload.module";
import { WorkflowStepAppAssetsComponent } from './workflow-step-app-assets.component';
import { WorkflowAppAssetsDmCoverComponent } from './workflow-app-assets-dm-cover/workflow-app-assets-dm-cover.component';
import { WorkflowAppAssetsVideoThumbComponent } from './workflow-app-assets-video-thumb/workflow-app-assets-video-thumb.component';
import { WorkflowAppAssetsVideoLoopComponent } from './workflow-app-assets-video-loop/workflow-app-assets-video-loop.component';
import { WorkflowAppAssetsHotspotCoverComponent } from './workflow-app-assets-hotspot-cover/workflow-app-assets-hotspot-cover.component';
import { WorkflowAppAssetsUsefultipsCoverComponent } from './workflow-app-assets-usefultips-cover/workflow-app-assets-usefultips-cover.component';

@NgModule({
  declarations: [
    WorkflowStepAppAssetsComponent,
    WorkflowAppAssetsDmCoverComponent,
    WorkflowAppAssetsVideoThumbComponent,
    WorkflowAppAssetsVideoLoopComponent,
    WorkflowAppAssetsHotspotCoverComponent,
    WorkflowAppAssetsUsefultipsCoverComponent
],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
    AppRoutingModule,
    MatStepperModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    FileuploadModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatSortModule,
    FileSizeModule,
    MatDialogModule,
    MatIconModule,
    MatListModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatGridListModule
  ],
  exports: [
    WorkflowStepAppAssetsComponent,
    WorkflowAppAssetsDmCoverComponent
  ]
})
export class WorkflowStepAppAssetsModule { }
